//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        opts: {
            type: Array,
            default () {
                return [
                    {
                        text: '不限',
                        value: ''
                    },
                    {
                        text: '清水',
                        value: '清水'
                    },
                    {
                        text: '精装',
                        value: '精装'
                    }
                ]
            }
        },
        actived: {
            type: String,
            default: ''
        },
        showbtn: Boolean
    },
    data () {
        return {
            selected: ''
        }
    },
    onUnload () {
        this.selected = ''
    },
    watch: {
        actived (v) {
            this.selected = v
        }
    },
    methods: {
        onSelect (e) {
            this.selected = e.currentTarget.dataset.value
            this.confirm()
        },
        reset () {
            this.selected = ''
        },
        confirm () {
            this.$emit('change', this.selected)
        }
    }
}
